/* eslint-disable no-nested-ternary */
const commercialMessageOfferTypeTriggers = [
    'new',
    'new-bti',
    'new-tro',
    'nlp',
    'family',
];
const priceComparisonOfferTypeTriggers = ['tro', 'new-tro'];
const btiOfferTypeTriggers = ['bti', 'new-bti'];
const hasCommercialMessage = (priceOfferType, commercialMessageProps) => {
    return ((commercialMessageOfferTypeTriggers.includes(priceOfferType) ||
        Boolean(commercialMessageProps)) &&
        (commercialMessageProps === null || commercialMessageProps === void 0 ? void 0 : commercialMessageProps.message) !== '' &&
        priceOfferType !== 'family-romania');
};
const getCommercialMessageVariant = (priceOfferType) => {
    return priceOfferType.includes('new')
        ? 'new'
        : priceOfferType === 'nlp'
            ? 'nlp'
            : priceOfferType === 'family'
                ? 'family'
                : undefined;
};
const hasBTI = (priceOfferType) => {
    return btiOfferTypeTriggers.includes(priceOfferType);
};
const hasComparisonPrice = (hasComparisonPriceProps, priceOfferType) => {
    return (hasComparisonPriceProps &&
        priceComparisonOfferTypeTriggers.includes(priceOfferType));
};
export { getCommercialMessageVariant, hasCommercialMessage, hasComparisonPrice, hasBTI, };
